module.exports = __webpack_public_path__ + "static/img/no-record-icon.9933d08.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/no-record-icon.png
// module id = UwrI
// module chunks = 66